import { ChevronRight, type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Mục gập "Quy tắc áp dụng · Đã chốt …" của một trang đã chốt quy tắc (19/09/2026 — thay các thẻ vàng "chờ khách xác nhận" khi đi lần
 * lượt các mục vàng trên menu). Trung tính, gập sẵn: người dùng tra khi cần, không phải cảnh báo. Chữ lấy từ `${ns}.rulesTitle`,
 * `${ns}.rulesDecided` và `${ns}.rules.<quy tắc>.title / .body` — mỗi trang một không gian tên.
 */
export function SettledRules({ ns, rules, icon: Icon }: { ns: string; rules: readonly string[]; icon: LucideIcon }) {
  const { t } = useTranslation();
  return (
    <details className="group/rules rounded-md border border-line bg-surface text-sm">
      <summary className="flex cursor-pointer list-none items-center gap-2 px-4 py-2.5 text-ink [&::-webkit-details-marker]:hidden">
        <ChevronRight className="size-3.5 shrink-0 text-ink-soft transition-transform group-open/rules:rotate-90" aria-hidden="true" />
        <Icon className="size-4 shrink-0 text-ink-soft" aria-hidden="true" />
        <span className="font-medium">{t(`${ns}.rulesTitle`)}</span>
        <span className="text-xs text-ink-faint">· {t(`${ns}.rulesDecided`)}</span>
      </summary>
      <dl className={`grid gap-x-6 gap-y-3 border-t border-line px-4 py-3 ${rules.length > 3 ? "md:grid-cols-2 xl:grid-cols-3" : "lg:grid-cols-3"}`}>
        {rules.map((rule) => (
          <div key={rule}>
            <dt className="text-xs font-semibold text-ink">{t(`${ns}.rules.${rule}.title`)}</dt>
            <dd className="mt-1 text-xs text-ink-soft">{t(`${ns}.rules.${rule}.body`)}</dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
